import { fetchWithToken } from "../helpers/fetch";
import { lesseeActions } from "../store/lesseeSlice";

export const startGetListPendingInvoices = () => {
  return async (dispatch) => {
    dispatch(lesseeActions.startLoadingListPendingInvoices());
    try {
      const response = await fetchWithToken("api/v1/pending_invoices");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(lesseeActions.loadListPendingInvoices(body));
        dispatch(lesseeActions.stopLoadingListPendingInvoices());
      }
    } catch (error) {
      dispatch(
        lesseeActions.errorListPendingInvoices("Error obteniendo informacion")
      );
    }
  };
};
